module.exports = __webpack_public_path__ + "static/media/LockMenu3.1c4cdef8.png";